// Small tag badge shown next to a user's name when they belong to a clan.
// Deliberately a <span>, not the shared <Badge> (which renders a <div>) — callers
// place this inside inline text contexts (e.g. a <p> byline), where a nested <div>
// is invalid HTML and triggers a hydration error.
export function ClanTagBadge({ tag, className }: { tag?: string | null; className?: string }) {
  if (!tag) return null;
  return (
    <span
      className={`badge inline-flex items-center rounded-md border border-transparent bg-secondary px-2 py-0 h-5 leading-5 font-mono text-xs font-semibold text-[var(--badge-text-secondary)] ${className ?? ""}`}
    >
      [{tag}]
    </span>
  );
}
